import { render, staticRenderFns } from "./CompraConfirmada.vue?vue&type=template&id=e8ce2a24&scoped=true"
import script from "./CompraConfirmada.vue?vue&type=script&lang=js"
export * from "./CompraConfirmada.vue?vue&type=script&lang=js"
import style0 from "./CompraConfirmada.vue?vue&type=style&index=0&id=e8ce2a24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ce2a24",
  null
  
)

export default component.exports